import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type Month = {
	month: string;
	date: string;
};

export async function fetchAwardsListMonths(): Promise<
	| {
			status: "success";
			data: Month[];
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get("/monthly-ranking/list-months");

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
